import React from "react";

// One-colour contact marks (Instagram, Facebook, email, mail), drawn in
// currentColor so they take the green of the link they sit in (Devin
// 2026-10-16).

export const InstagramIcon = () => (
  <svg className="soc" viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" fill="none" stroke="currentColor" strokeWidth="2">
    <rect x="3" y="3" width="18" height="18" rx="5" />
    <circle cx="12" cy="12" r="4.2" />
    <circle cx="17.4" cy="6.6" r="1.1" fill="currentColor" stroke="none" />
  </svg>
);

export const FacebookIcon = () => (
  <svg className="soc" viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" fill="currentColor">
    <path d="M12 2C6.48 2 2 6.48 2 12c0 4.99 3.66 9.13 8.44 9.88v-6.99H7.9V12h2.54V9.8c0-2.5 1.49-3.89 3.78-3.89 1.09 0 2.24.2 2.24.2v2.46h-1.26c-1.24 0-1.63.77-1.63 1.56V12h2.78l-.44 2.89h-2.34v6.99C18.34 21.13 22 16.99 22 12c0-5.52-4.48-10-10-10z" />
  </svg>
);

export const EmailIcon = () => (
  <svg className="soc" viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" fill="none" stroke="currentColor" strokeWidth="2" strokeLinejoin="round">
    <rect x="3" y="5" width="18" height="14" rx="2.5" />
    <path d="m4 7 8 6 8-6" />
  </svg>
);

export const MailboxIcon = () => (
  <svg className="soc" viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" fill="none" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" strokeLinecap="round">
    <path d="M7 6h10a4 4 0 0 1 4 4v8H3v-8a4 4 0 0 1 4-4z" />
    <path d="M7 6a4 4 0 0 1 4 4v8" />
    <path d="M14 3v6M14 3h3v2.5h-3" />
    <path d="M10 21v-3" />
  </svg>
);
